// Values must be hard coded from Auth0 Application settings for now
export const redirectUri = window.location.origin;
export var Region;
(function (Region) {
    Region["US"] = "US";
    Region["AU"] = "AU";
    Region["EU"] = "EU";
    Region["JP"] = "JP";
    Region["UK"] = "UK";
})(Region || (Region = {}));
export const Auth0ClientIdMap = {
    [Region.US]: 'FwFRoGvDFXlyhncKxEc3zZu8kTGFVMbh',
    [Region.AU]: 'Mpptu1l97mJZVMVnibwSiYSVaFrRKski',
    [Region.EU]: 'l4QjTvfEmmipXU0qUJlNeK7kkszADgr9',
    [Region.JP]: '5SxrfZPXifUeU3hTzBp7Rbg5eDQMucfQ',
    [Region.UK]: 'waXLnrYDwJ9JN8ojUv2Bi5F2TckhLKBV',
};
export const Auth0RegionsMap = {
    [Region.US]: 'us',
    [Region.UK]: 'uk',
    [Region.EU]: 'eu',
    [Region.JP]: 'jp',
    [Region.AU]: 'au',
};
